module.exports = __webpack_public_path__ + "static/NotoSansThai-Regular-68cede968a6942a74d723139889a16d4.ttf";